<mat-dialog-content>
  <div class="row mb-2">
    <div class="col-3">
      <label>Data</label>
    </div>
    <div class="col-3">
      <span>{{ operationDate | date: "dd/MM/yyyy":"+0000" }}</span>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-3">
      <label>Conta</label>
    </div>
    <div class="col-3">
      <span>{{ bankAccount }}</span>
    </div>
  </div>

  <div class="row mb-2">
    <table class="table table-striped">
      <thead class="thead-dark">
        <th scope="col">Data</th>
        <th scope="col">Origem</th>
        <th scope="col">Banco</th>
        <th scope="col">Agência</th>
        <th scope="col">Conta</th>
        <th scope="col">Valor</th>
        <th scope="col">No. Boleta</th>
      </thead>
      <tbody>
        <tr *ngFor="let item of transfers">
          <td>{{ item.data | date: "dd/MM/yyyy":"+0000" }}</td>
          <td>{{ item.contraparte.inscricao }}</td>
          <td>{{ item.contraparte.banco }}</td>
          <td>{{ item.contraparte.agencia }}</td>
          <td>{{ item.contraparte.conta }}</td>
          <td>{{ item.valor | currency: "R$":"symbol":"1.2-2" }}</td>
          <td>{{ item.ticketId }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Fechar</button>
  </mat-dialog-actions>
</mat-dialog-content>
